import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StructureComponent } from './structure.component';
import {MydocmaTreeModule} from '@mydocma/component-library/src/lib/tree';
import { StructureTreeComponent } from './structure-tree/structure-tree.component';
import { AppContainerModule } from '@mydocma/app-container';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderModule } from '@mydocma/component-library';
import { MydocmaHighlightModule } from '@mydocma/component-library/src/lib/highlight';


@NgModule({
  declarations: [
    StructureComponent,
    StructureTreeComponent
  ],
  imports: [
    CommonModule,
    MydocmaTreeModule,
    AppContainerModule,
    TranslateModule,
    LoaderModule,
    MydocmaHighlightModule
  ],
  providers: [
  ],
  exports: [
    StructureComponent,
    StructureTreeComponent
  ]
})
export class StructureModule { }
